import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MasterPage from '../../layouts/MasterPage';
import AuthenticationManager from '../../services/StorageJWT';
import { DatePicker } from 'zaman';
import profileAPI from '../../api/profileAPI';
import moment from 'jalali-moment';
import PopupBox from '../../components/PopupBox';
import { useAuth } from '../../provider/AuthProvider';

const Profile = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  const [birthday, setBirthday] = useState('');
  const [address, setAddress] = useState('');
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState('');
  const [show, setShow] = useState(false);
  var _auth =new AuthenticationManager();
  const {token} =useAuth();
  useEffect(() => {
    setEmail(token.user.email);

    setName(token.user.name??"");
  //  alert( moment(token.user.birthday, 'YYYY-MM-DD[T]hh:mm:ss[Z]').format("YYYY-MM-DD"))
    setGender(token.user.gender??"");
    setBirthday(token.user.birthday??"");

    setAddress(token.user.address??"");
  }, []);
  const onSubmit = () => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email && !re.test(email)) {
      setShow(true);
      setErrorText('ایمیل وارد شده صحیح نمی باشد');
      return;
    }
    if (name !== '') {
      setError(true);
      profileAPI
        .updateProfile(
          {
            birthday: birthday,
            name: name,
            email: email,
            gender: gender,
            address: address,
          },
          _auth._token
        )
        .then((res) => {
          _auth.updateProfile(res);
          setShow(true);
          setErrorText('اطلاعات شما به روز رسانی شد.');
        })
        .catch((e) => {
          if (e.response) {
            if (e.response.data.error) {
              setShow(true);
              setErrorText(e.response.data.error);
            }
          }
        })
        .finally(() => setLoading(false));
    } else setError(true);
  };
  return (
    <MasterPage>
      <div className="structure-page structure-page-7 login p-3 body menu ">
        <div className="text-center w-100 profile">
          <div className="form-group   w-100">
            <label htmlFor="name" className='w-100'>
              نام و نام خانوادگی <span className="text-danger">*</span>
           
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              value={name}
              className={`form-control w-100 ${
                !name && error ? 'is-invalid' : ''
              }`}
              placeholder="تایپ کنید"
            />
             </label>
          </div>
          <div className="form-group   w-100">
            <label htmlFor="name" className='w-100'>موبایل
            <input
              type="text"
              disabled
              value={_auth._token.user.mobile}
              className={`form-control w-100 `}
            />
            </label>
          </div>
          <div className="form-group   w-100">
            <label htmlFor="name" className='w-100'>آدرس ایمیل
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              value={email}
              className={`form-control w-100 `}
              placeholder="Email Address"
              
            />
            </label>
          </div>
          <div className="form-group  w-100" dir="rtl">
            <label htmlFor="name" className='w-100'>تاریخ تولد
           { birthday? <DatePicker
              round="x2"
      
              defaultValue={moment(birthday).format("YYYY-MM-DD")}
              accentColor="#da4242"
              inputAttributes={{
                class: 'form-control w-100 bg-white',
                placeholder: 'انتخاب کنید',
    
              }}
              onChange={(e) =>{

               setBirthday(e.value)
              }}
            />:
            null}
            { !birthday? <DatePicker
              round="x2"
      
              accentColor="#da4242"
              inputAttributes={{
                class: 'form-control w-100 bg-white',
                placeholder: 'انتخاب کنید',
    
              }}
              onChange={(e) =>{

               setBirthday(e.value)
              }}
            />:
            null}
            </label>
          </div>
          <div className="form-group  w-100">
            <label htmlFor="name" className='w-100'>جنسیت
            <select
              onChange={(e) => setGender(e.target.value)}
              type="text"
              value={gender}
              className={`form-select w-100`}
              placeholder="مشخص کنید"
            >
              <option value="">انتخاب کنید</option>
              <option value="man">مرد</option>
              <option value="woman">زن</option>
            </select>
            </label>
          </div>
          
          <div className="form-group   w-100">
            <label htmlFor="name" className='w-100'>آدرس من
            <textarea
              rows={3}
              onChange={(e) => setAddress(e.target.value)}
              type="text"
            value={address}
              className={`form-control w-100          `}
              placeholder="تایپ کنید"
            ></textarea>
            </label>
          </div>
          <PopupBox show={show} setShow={setShow} text={errorText} />
        </div>
        <div className="d-grid w-100">
          <button onClick={onSubmit} className=" btn btn-submit  ">
            ثبت
          </button>
          <button
            onClick={() => window.history.back()}
            className=" btn btn-return  "
          >
            بازگـشـت
          </button>
        </div>
      </div>
    </MasterPage>
  );
};

export default Profile;
